import React from "react";

import { getRangeMS } from "../../../../redux/directoryMaintenance/rangeMS/actionsRangeMS";

import GeneralSectionComponent from "../generalSectionComponent";

import { RANGE_MS } from "../../../../components/GeneralComponents/SearchTable/TablesColumns";
import RangeMSModal from "./rangeMSModal/rangeMSModal";

function RangeMS() {
  return (
    <GeneralSectionComponent
      title="Диапазон регистрационных номеров МС"
      dataFromStateSelector={(state) => state.dictionaryReducer.allRangeMS}
      getAction={getRangeMS}
      headerColumns={RANGE_MS}
      ModalComponent={RangeMSModal}
    />
  );
}

export default RangeMS;
